import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
  selectBrand,
  selectContent,
  selectCustomer,
  selectCustomerOrders,
  fetchCustomerOrders,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import {
  Button,
  Content,
  HeaderDefault,
  Loading,
  Main,
  PageContainer,
  PageContent,
  PageError,
  PageTitle,
} from 'components'
import OrdersList from './OrdersList'

const Orders = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const increment = 20
  const limit = 60
  const [count, setCount] = useState(increment)
  const orders = useAppSelector(selectCustomerOrders)
  const { entities, loading, error } = orders
  const [recentOrders, setRecentOrders] = useState(entities.slice(0, count))
  const { title: siteTitle } = useAppSelector(selectBrand) || {}
  const { orders: config } = useAppSelector(selectContent) || {}
  const { auth } = useAppSelector(selectCustomer)
  const isLoading = loading === 'pending'

  useEffect(() => {
    if (!auth) return navigate('/account')
  }, [auth, navigate])

  useEffect(() => {
    dispatch(fetchCustomerOrders(limit + 1))
  }, [dispatch])

  useEffect(() => {
    setRecentOrders(entities.slice(0, count))
  }, [entities, count])

  const loadMore = () => {
    setCount(Math.min(count + increment, limit))
  }

  if (!auth) return null

  return (
    <>
      <Helmet>
        <title>
          {config?.title} | {siteTitle}
        </title>
      </Helmet>
      <Content>
        <HeaderDefault />
        <Main>
          <PageContainer style={{ maxWidth: '114rem' }}>
            <PageTitle {...config} />
            <PageError error={error} />
            {recentOrders.length ? (
              <>
                <OrdersList orders={recentOrders} />
                {entities.length - 1 > count && (
                  <Button onClick={loadMore}>Load more recent orders</Button>
                )}
              </>
            ) : (
              <PageContent>
                {isLoading ? (
                  <Loading text="Retrieving your order history. Please sit tight." />
                ) : (
                  <p>Looks like you don't have any orders yet.</p>
                )}
              </PageContent>
            )}
          </PageContainer>
        </Main>
      </Content>
    </>
  )
}

export default Orders
